var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65 44.5215H15V67.6615C15 68.7652 15.7238 69.739 16.7813 70.0565C21.805 71.5627 35.9325 75.8015 39.2812 76.8065C39.75 76.9465 40.25 76.9465 40.7188 76.8065C44.0675 75.8015 58.195 71.5627 63.2188 70.0565C64.2763 69.739 65 68.7652 65 67.6615C65 61.8665 65 44.5215 65 44.5215Z",
    fill: "url(#paint0_linear_970_25855)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9984 44.5215H39.9984C39.9984 44.5215 39.7559 76.9115 39.9984 76.9115C40.2409 76.9115 40.4822 76.8765 40.7172 76.8065C44.0659 75.8015 58.1934 71.5627 63.2172 70.0565C64.2747 69.739 64.9984 68.7652 64.9984 67.6615C64.9984 61.8665 64.9984 44.5215 64.9984 44.5215Z",
    fill: "url(#paint1_linear_970_25855)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9993 52.6327L14.9993 44.5215C14.9993 44.5215 10.6156 51.0215 8.65559 53.9265C8.43559 54.2527 8.38184 54.6615 8.50934 55.0327C8.63809 55.404 8.93184 55.6927 9.30559 55.8152C14.0543 57.3577 28.1118 61.9252 31.7993 63.1227C32.3281 63.2952 32.9081 63.0965 33.2206 62.6352C34.8968 60.1615 39.9993 52.6327 39.9993 52.6327Z",
    fill: "url(#paint2_linear_970_25855)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65 44.5215L40 52.6327C40 52.6327 45.1025 60.1615 46.7788 62.6352C47.0913 63.0965 47.6713 63.2952 48.2 63.1227C51.8875 61.9252 65.945 57.3577 70.6938 55.8152C71.0675 55.6927 71.3613 55.404 71.49 55.0327C71.6175 54.6615 71.5638 54.2527 71.3438 53.9265C69.3838 51.0215 65 44.5215 65 44.5215Z",
    fill: "url(#paint3_linear_970_25855)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9472 27.4821C33.6347 27.0234 33.0559 26.8246 32.5272 26.9971C28.8422 28.1934 14.7809 32.7621 10.0322 34.3059C9.6584 34.4271 9.3634 34.7159 9.2359 35.0871C9.1084 35.4584 9.16215 35.8684 9.38215 36.1934C11.1872 38.8709 14.9984 44.5209 14.9984 44.5209L39.9984 36.3821C39.9984 36.3821 35.5084 29.7784 33.9472 27.4821Z",
    fill: "url(#paint4_linear_970_25855)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6162 36.1934C70.8363 35.8684 70.89 35.4584 70.7625 35.0871C70.635 34.7159 70.34 34.4271 69.9662 34.3059C65.2175 32.7621 51.1563 28.1934 47.4713 26.9971C46.9425 26.8246 46.3637 27.0234 46.0512 27.4821C44.49 29.7784 40 36.3821 40 36.3821L65 44.5209C65 44.5209 68.8113 38.8709 70.6162 36.1934Z",
    fill: "url(#paint5_linear_970_25855)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65 44.5216L40 36.3828L15 44.5216L40 52.6328L65 44.5216Z",
    fill: "url(#paint6_linear_970_25855)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40 52.6328V36.3828L15 44.5216L40 52.6328Z",
    fill: "url(#paint7_linear_970_25855)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9765 39.9723C34.4565 39.6323 33.9877 39.2685 33.5715 38.8873C33.064 38.421 32.2727 38.4548 31.8052 38.9635C31.339 39.471 31.3727 40.2623 31.8815 40.7285C32.3927 41.1985 32.969 41.646 33.609 42.0648C34.1865 42.4423 34.9615 42.2798 35.339 41.7023C35.7165 41.1248 35.554 40.3498 34.9765 39.9723Z",
    fill: "#007BFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0825 36.1332C30.7112 35.6294 30.3975 35.1232 30.14 34.6169C29.8275 34.0019 29.0737 33.7569 28.4587 34.0694C27.8437 34.3819 27.5987 35.1357 27.9112 35.7507C28.2287 36.3732 28.6137 36.9969 29.07 37.6157C29.4787 38.1707 30.2612 38.2894 30.8175 37.8807C31.3725 37.4707 31.4912 36.6882 31.0825 36.1332Z",
    fill: "#007BFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2543 31.0327C29.2668 30.5289 29.3405 30.0402 29.4755 29.5714C29.6655 28.9089 29.2818 28.2152 28.618 28.0252C27.9555 27.8352 27.2618 28.2189 27.0718 28.8827C26.8805 29.5527 26.773 30.2514 26.7543 30.9702C26.738 31.6602 27.283 32.2339 27.973 32.2502C28.663 32.2677 29.2368 31.7227 29.2543 31.0327Z",
    fill: "#007BFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1772 26.857C31.4984 26.5595 31.8584 26.2845 32.2522 26.0358C32.8359 25.667 33.0109 24.8945 32.6434 24.312C32.2747 23.7283 31.5022 23.5533 30.9184 23.9208C30.3897 24.2545 29.9097 24.6233 29.4784 25.0233C28.9722 25.492 28.9422 26.2833 29.4109 26.7895C29.8797 27.2958 30.6709 27.3258 31.1772 26.857Z",
    fill: "#007BFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8251 24.7003C36.4539 24.5841 37.1201 24.5091 37.8226 24.4803C38.5126 24.4503 39.0476 23.8666 39.0189 23.1778C38.9901 22.4891 38.4064 21.9528 37.7164 21.9816C36.8914 22.0166 36.1089 22.1053 35.3701 22.2416C34.6926 22.3678 34.2426 23.0203 34.3689 23.6978C34.4939 24.3766 35.1464 24.8253 35.8251 24.7003Z",
    fill: "#007BFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3406 24.6266C43.4068 24.6391 44.3993 24.6016 45.3206 24.5204C46.0081 24.4591 46.5168 23.8516 46.4556 23.1641C46.3943 22.4779 45.7868 21.9691 45.0993 22.0304C44.2556 22.1041 43.3468 22.1391 42.3693 22.1266C41.6793 22.1191 41.1131 22.6729 41.1056 23.3616C41.0968 24.0516 41.6506 24.6191 42.3406 24.6266Z",
    fill: "#007BFF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4296 23.7539C50.6671 23.3751 51.7121 22.8901 52.5871 22.3339C53.1684 21.9626 53.3409 21.1901 52.9696 20.6076C52.5996 20.0264 51.8259 19.8539 51.2434 20.2251C50.5396 20.6726 49.6959 21.0576 48.6984 21.3626C48.0396 21.5651 47.6671 22.2639 47.8696 22.9239C48.0709 23.5839 48.7709 23.9551 49.4296 23.7539Z",
    fill: "#007BFF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7919 18.8358C56.3819 17.6158 56.6082 16.3258 56.5507 15.082C56.5182 14.392 55.9319 13.8595 55.2432 13.892C54.5544 13.9245 54.0207 14.5095 54.0532 15.1983C54.0932 16.0433 53.9407 16.9195 53.5407 17.7483C53.2407 18.3695 53.5007 19.1183 54.1219 19.4183C54.7432 19.7183 55.4919 19.457 55.7919 18.8358Z",
    fill: "#007BFF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9946 10.6619C54.0834 9.43061 52.8471 8.57311 51.4996 8.29686C50.8234 8.15936 50.1621 8.59436 50.0234 9.27061C49.8859 9.94686 50.3221 10.6081 50.9971 10.7469C51.7746 10.9056 52.4596 11.4394 52.9859 12.1506C53.3971 12.7044 54.1809 12.8206 54.7346 12.4106C55.2896 11.9994 55.4059 11.2156 54.9946 10.6619Z",
    fill: "#007BFF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M38.666 8.5385C40.0185 0.879752 51.7398 1.37475 44.916 8.5385H38.666Z",
    fill: "url(#paint8_linear_970_25855)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M38.666 10.4785C40.0185 18.136 51.7398 17.6423 44.916 10.4785H38.666Z",
    fill: "url(#paint9_linear_970_25855)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5527 10.7715H46.9227C47.6127 10.7715 48.1727 10.2115 48.1727 9.52148C48.1727 8.83148 47.6127 8.27148 46.9227 8.27148H38.5527C37.864 8.27148 37.3027 8.83148 37.3027 9.52148C37.3027 10.2115 37.864 10.7715 38.5527 10.7715Z",
    fill: "#007BFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_970_25855",
    x1: 15,
    y1: 60.7165,
    x2: 65,
    y2: 60.7165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_970_25855",
    x1: 39.8909,
    y1: 60.7165,
    x2: 64.9984,
    y2: 60.7165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4BBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DA3BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_970_25855",
    x1: 15.1656,
    y1: 44.5115,
    x2: 18.6596,
    y2: 67.6282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_970_25855",
    x1: 40.1013,
    y1: 52.5477,
    x2: 66.4559,
    y2: 67.7051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_970_25855",
    x1: 11.7259,
    y1: 39.6696,
    x2: 15.4972,
    y2: 21.8918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_970_25855",
    x1: 46.6925,
    y1: 26.6959,
    x2: 48.041,
    y2: 48.6393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_970_25855",
    x1: 15,
    y1: 44.5078,
    x2: 65,
    y2: 44.5078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_970_25855",
    x1: 42.56,
    y1: 36.0191,
    x2: 43.0988,
    y2: 56.2103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4BBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DA3BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_970_25855",
    x1: 38.666,
    y1: 5.7585,
    x2: 47.0348,
    y2: 5.7585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_970_25855",
    x1: 38.666,
    y1: 13.2585,
    x2: 47.0348,
    y2: 13.2585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyList);
export default __webpack_public_path__ + "static/media/empty-list.0880ffbc797778d3e242a80f26147f86.svg";
export { ForwardRef as ReactComponent };